module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00035.eba68678.jpg";